import { getRefreshToken, useDeliveries } from '@vgrubs/components';
import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.NX_API_URL;

const useDeliveriesSocket = () => {
  const lastSoundTimeRef = useRef(0);
  const { updateDelivery, setHasNewDelivery } = useDeliveries((state) => state);

  const refreshToken = getRefreshToken();

  useEffect(() => {
    if (!refreshToken) return;

    const socket = io(SOCKET_URL, {
      path: '/delivery',
      transports: ['websocket'],
      auth: {
        authorization: refreshToken,
      },
    });

    socket.on('connection_successful', () => {
    });

    socket.on('new_delivery', (data) => {
      setHasNewDelivery(true);

      const now = Date.now();
      const MIN_INTERVAL = 1000;
      if (now - lastSoundTimeRef.current > MIN_INTERVAL) {
        lastSoundTimeRef.current = now;

        const audio = new Audio('/sound3.mp3');
        audio.play().catch((e) => console.error('Audio play error:', e));
      }
    });

    socket.on('update_delivery', (updatedDelivery) => {
      updateDelivery(updatedDelivery); // ✅ Update delivery list in store
    });

    socket.on('connect_error', (err) => {
      console.error('Connection Error:', err.message);
      console.error('Error Details:', err);
    });

    return () => {
      socket.off('new_delivery');
      socket.off('update_delivery');
      socket.off('connect_error');
      socket.off('disconnect');
      socket.disconnect();
    };
  }, [refreshToken, updateDelivery]);

  return {};
};

export default useDeliveriesSocket;
